var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("vms__ui-icon " + (_vm.name.startsWith('vms') ? '' : 'mdi') + " " + _vm.name),style:(_vm.indents)})}
var staticRenderFns = []

export { render, staticRenderFns }